






















































import { Component, Prop, Vue } from "vue-property-decorator";
import { IUser } from "@/@types/admin/user/user";
import { IBar } from "@/@types/menu/bars/bars";
import { IOrder } from "@/@types/orders/new-order";

import BarOrderMenuSlidebar from "@/components/orders/bars/bar-order-menu-slidebar.vue";
import OrderCard from "@/components/orders/bars/order-card.vue";
import HeaderOrderList from "@/components/orders/bars/header-order-list.vue";

@Component({ components: { OrderCard, BarOrderMenuSlidebar, HeaderOrderList } })
export default class OrderList extends Vue {
  @Prop({ type: Array, default: () => [] }) orderList!: Array<IOrder>;
  @Prop({ type: Array, default: () => [] }) managers!: Array<IUser>;
  @Prop({ type: Array, default: () => [] }) routes!: Array<string>;
  @Prop({ type: Array, default: () => [] }) bars!: Array<IBar>;
  @Prop({ type: String, default: "" }) activeBar!: string;
  @Prop({ type: String, default: "" }) route!: string;
  @Prop({ type: String, default: "" }) status!: string;
  @Prop({ type: String, default: "" }) manager_id!: string;
  @Prop({ type: Object, default: null }) manager!: IUser;
  @Prop({ type: Object, default: null }) bar!: IBar;

  search = "";

  get orders(): Array<IOrder> {
    if (this.search) {
      const search = this.search && this.search.toLowerCase();
      return this.orderList.filter((item) => {
        if (item.room_number)
          return (
            item.room_number.toLowerCase().indexOf(search.toLowerCase()) > -1
          );
      });
    }

    let orders = this.orderList;
    if (this.activeBar) {
      orders = orders.filter((order) => {
        const shop = order.cart.find((item) => item.shop_id == this.activeBar);
        if (shop) return order;
      });
    }

    if (this.manager_id) {
      orders = orders.filter((order) => {
        if (order.manager_id == this.manager_id) return order;
      });
    }

    if (this.status) {
      orders = orders.filter((order) => {
        if (order.status == this.status) return order;
      });
    }

    return orders;
  }

  get orderCount(): number {
    let i = 0;
    const status = this.status ? this.status : "new";
    this.orderList.forEach((item) => {
      if (item.status == status) i++;
    });
    return i;
  }
}
